import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useTranslation } from '../../context/TranslationContext.jsx';

import InstructionsForUse from './InstructionsForUse.jsx';
import ManufacturerInformation from './ManufacturerInformation.jsx';
import {
  AccordionIcon,
  RegulatoryContent,
  RegulatoryDetails,
  RegulatorySection,
  RegulatorySummary,
  RegulatoryTitle,
} from './styles.js';

const RegulatoryInformation = ({ variant = 'embedded' }) => {
  const { translate } = useTranslation();
  const [expandedSection, setExpandedSection] = useState(null);
  const isCard = variant === 'card';

  const sections = [
    {
      id: 'instructions',
      title: translate('authPage.legal.instructionsTitle'),
      content: <InstructionsForUse variant={variant} />,
    },
    {
      id: 'manufacturer',
      title: translate('authPage.legal.manufacturerTitle'),
      content: <ManufacturerInformation variant={variant} />,
    },
  ];

  return (
    <RegulatorySection
      component="section"
      aria-label={translate('authPage.legal.sectionAriaLabel')}
    >
      {sections.map(({ id, title, content }, index) => (
        <RegulatoryDetails
          key={id}
          displayVariant={variant}
          isLast={index === sections.length - 1}
          open={isCard ? expandedSection === id : undefined}
        >
          <RegulatorySummary
            displayVariant={variant}
            aria-expanded={isCard ? expandedSection === id : undefined}
            onClick={
              isCard
                ? (event) => {
                    event.preventDefault();
                    setExpandedSection((current) => (current === id ? null : id));
                  }
                : undefined
            }
          >
            <RegulatoryTitle component="span" variant="subtitle2" displayVariant={variant}>
              {title}
            </RegulatoryTitle>
            <AccordionIcon className="accordionIcon" displayVariant={variant} aria-hidden="true">
              {isCard ? <ExpandMoreIcon fontSize="inherit" /> : '+'}
            </AccordionIcon>
          </RegulatorySummary>
          <RegulatoryContent displayVariant={variant}>{content}</RegulatoryContent>
        </RegulatoryDetails>
      ))}
    </RegulatorySection>
  );
};

export default RegulatoryInformation;
